module.exports = __webpack_public_path__ + "static/group-join-c243cfbd9137ff5d175a6d5153666cfb.png";